import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import { IProps } from './SelectFromCloudPopup.types';

export const openSelectFromCloudPopup = ({ onSuccess, onClose, isEmpty }) =>
    openPopupHelper<IProps>({ popupName: popupNames.SELECT_FROM_CLOUD_DIALOG, data: { onSuccess, onClose, isEmpty } });
